import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

import { InputCustomField } from './InputCustomField.entity';

export class InputReZahlung<T extends EMode = EMode.entity> {
  /** Alias: code */
  code?: any;
  /** Alias: benutzerCode */
  benutzerCode?: any;
  /** Alias: buchungsDatum */
  buchungsDatum?: any;
  /** Alias: datev */
  datev?: any;
  /** Alias: datum */
  datum?: any;
  /** Alias: konto */
  konto?: any;
  /** Alias: notiz */
  notiz?: any;
  /** Alias: sachkontoCode */
  sachkontoCode?: any;
  /** Alias: sachkonto */
  sachkonto?: any;
  /** Alias: summe */
  summe?: any;
  /** Alias: reCode */
  reCode?: any;
  /** Alias: customFields */
  customFields?: InputCustomField<T>[];

  __typename?: string;
}

const fields: FieldDefinitions<InputReZahlung> = {
  code: {
    alias: 'code',
  },
  benutzerCode: {
    alias: 'benutzerCode',
  },
  buchungsDatum: {
    alias: 'buchungsDatum',
  },
  datev: {
    alias: 'datev',
  },
  datum: {
    alias: 'datum',
  },
  konto: {
    alias: 'konto',
  },
  notiz: {
    alias: 'notiz',
  },
  sachkontoCode: {
    alias: 'sachkontoCode',
  },
  sachkonto: {
    alias: 'sachkonto',
  },
  summe: {
    alias: 'summe',
  },
  reCode: {
    alias: 'reCode',
  },
  customFields: {
    alias: 'customFields',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputReZahlungEntityDefinition: EntitiyDefinition<InputReZahlung> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputReZahlung',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
